import React, { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { RecordAudioTestPreview } from "./render";

export const RecordAudioTest = () => {
    const [searchParams] = useSearchParams();
    const [audioHistory, setAudioHistory] = useState([]);

    // Leer parámetros de URL
    const attrs = useMemo(() => ({
        vtBackgroundColor: searchParams.get("vtBackgroundColor") || "#FFFFFF",
        vtButtonSize: searchParams.get("vtButtonSize") || "20",
        vtIconSize: searchParams.get("vtIconSize") || "10",
    }), [searchParams]);

    const handleAudioRecorded = (base64Audio) => {
        // En lugar de raiseEvent, hacemos console.log y mostramos en la interfaz
        console.log("🎤 Audio grabado:");
        console.log("Formato:", "audio/wav");
        console.log("Base64:", base64Audio);
        console.log("Longitud:", base64Audio.length, "caracteres");
        console.log("---");

        // Agregar a la lista de audios
        setAudioHistory((prev) => [
            ...prev,
            {
                timestamp: new Date().toLocaleTimeString(),
                base64: base64Audio,
                format: "audio/wav",
            },
        ]);
    };

    const clearHistory = () => {
        setAudioHistory([]);
    };

    return (
        <div style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            backgroundColor: '#1e1e1e',
            color: '#fff',
            fontFamily: 'monospace'
        }}>
            {/* Panel izquierdo: Grabador */}
            <div
                style={{
                    width: '30%',
                    height: '100%',
                    margin: 0,
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxSizing: 'border-box',
                    backgroundColor: attrs.vtBackgroundColor.startsWith("#")
                        ? attrs.vtBackgroundColor
                        : "#" + attrs.vtBackgroundColor,
                    borderRight: '2px solid #ED0029'
                }}
            >
                <div style={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    color: '#000',
                    fontSize: '12px'
                }}>
                    <div><strong>Configuración:</strong></div>
                    <div>Color: {attrs.vtBackgroundColor}</div>
                    <div>Botón: {attrs.vtButtonSize}px</div>
                    <div>Icono: {attrs.vtIconSize}px</div>
                </div>

                <RecordAudioTestPreview
                    onAudioRecorded={handleAudioRecorded}
                    buttonSize={attrs.vtButtonSize}
                    iconSize={attrs.vtIconSize}
                />
            </div>

            {/* Panel derecho: Logs y preview */}
            <div style={{
                width: '70%',
                height: '100%',
                padding: '20px',
                overflowY: 'auto',
                boxSizing: 'border-box'
            }}>
                <h1 style={{ marginBottom: '20px', color: '#ED0029' }}>
                    Record Audio Test
                </h1>

                {/* Ejemplo de URL */}
                <div style={{
                    marginBottom: '20px',
                    padding: '15px',
                    backgroundColor: '#2d2d2d',
                    borderRadius: '5px'
                }}>
                    <h2 style={{ marginBottom: '10px', fontSize: '18px' }}>
                        Ejemplo de URL:
                    </h2>
                    <code style={{
                        display: 'block',
                        padding: '10px',
                        backgroundColor: '#1e1e1e',
                        borderRadius: '3px',
                        fontSize: '12px',
                        wordBreak: 'break-all'
                    }}>
                        /recordaudioTest?vtBackgroundColor=%23FFFFFF&vtButtonSize=20&vtIconSize=10
                    </code>
                </div>

                {/* Botón para limpiar historial */}
                <button
                    onClick={clearHistory}
                    style={{
                        marginBottom: '20px',
                        padding: '10px 20px',
                        backgroundColor: '#ED0029',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '14px'
                    }}
                >
                    Limpiar Historial
                </button>

                {/* Historial de audios */}
                <div style={{
                    padding: '15px',
                    backgroundColor: '#2d2d2d',
                    borderRadius: '5px'
                }}>
                    <h2 style={{ marginBottom: '10px', fontSize: '18px' }}>
                        Audios Grabados ({audioHistory.length}):
                    </h2>
                    <div style={{ fontSize: '14px' }}>
                        {audioHistory.length === 0 ? (
                            <div style={{ color: '#808080', fontStyle: 'italic' }}>
                                No hay audios grabados aún. Haz clic en el micrófono para grabar.
                            </div>
                        ) : (
                            audioHistory.map((audio, index) => (
                                <div
                                    key={index}
                                    style={{
                                        marginBottom: '20px',
                                        padding: '15px',
                                        backgroundColor: '#1e1e1e',
                                        borderRadius: '5px',
                                        borderLeft: '4px solid #0099ff'
                                    }}
                                >
                                    <div style={{
                                        marginBottom: '10px',
                                        color: '#808080'
                                    }}>
                                        [{audio.timestamp}] - Audio #{audioHistory.length - index}
                                    </div>

                                    <div style={{ marginBottom: '10px' }}>
                                        <strong>Formato:</strong> {audio.format}
                                    </div>

                                    <div style={{ marginBottom: '10px' }}>
                                        <strong>Tamaño:</strong> {audio.base64.length} caracteres
                                    </div>

                                    {/* Reproductor de audio */}
                                    <div style={{ marginBottom: '10px' }}>
                                        <strong>Reproducir:</strong>
                                        <audio
                                            controls
                                            src={audio.base64}
                                            style={{
                                                width: '100%',
                                                marginTop: '5px'
                                            }}
                                        />
                                    </div>

                                    {/* Base64 truncado */}
                                    <details>
                                        <summary style={{
                                            cursor: 'pointer',
                                            color: '#0099ff',
                                            marginBottom: '5px'
                                        }}>
                                            Ver Base64 completo
                                        </summary>
                                        <pre style={{
                                            marginTop: '10px',
                                            padding: '10px',
                                            backgroundColor: '#000',
                                            borderRadius: '3px',
                                            overflow: 'auto',
                                            fontSize: '10px',
                                            maxHeight: '200px',
                                            wordBreak: 'break-all',
                                            whiteSpace: 'pre-wrap'
                                        }}>
                                            {audio.base64}
                                        </pre>
                                    </details>

                                    {/* Botón de descarga */}
                                    <button
                                        onClick={() => {
                                            const link = document.createElement('a');
                                            link.href = audio.base64;
                                            link.download = `audio_${audio.timestamp.replace(/:/g, '-')}.wav`;
                                            link.click();
                                        }}
                                        style={{
                                            marginTop: '10px',
                                            padding: '8px 15px',
                                            backgroundColor: '#0099ff',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '3px',
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}
                                    >
                                        Descargar Audio (WAV)
                                    </button>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
